import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  ChangeDetectorRef,
  NgZone,
} from "@angular/core";
import {
  CalendarOptions,
  EventInput,
  EventClickArg,
} from "@fullcalendar/angular";
import thLocale from "@fullcalendar/core/locales/th";
import * as moment from "moment";
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { EventService } from "src/app/services/event.service";
import { environment } from "src/environments/environment";
import { NgxImageCompressService } from "ngx-image-compress";
import { MapsAPILoader, MouseEvent } from "@agm/core";
import { distinctUntilChanged } from "rxjs/internal/operators/distinctUntilChanged";
import { debounceTime } from "rxjs/internal/operators/debounceTime";
import { pairwise } from "rxjs/internal/operators/pairwise";
declare var $: any;

@Component({
  selector: "smart-plot-event",
  templateUrl: "./plot-event.component.html",
  styleUrls: [
    "./plot-event.component.css",
    "../platform-color/platform-color.css",
  ],
})
export class PlotEventComponent implements OnInit {
  @ViewChild("activeBtn") activeBtn: ElementRef;
  @Input() cropId: string;
  @Input() plotId: string;
  @Input() zoneId: string;
  userrole = sessionStorage.getItem("role");
  markers: marker[] = [];
  URLUPLOAD: any = environment.URLUPLOAD;
  INITIAL_EVENTS: EventInput[] = [];
  calendarOptions: CalendarOptions;
  //currentEvents: EventApi[] = [];
  pageName = "calendar"; //calendar, createEvent, editEvent, detailEvent
  loading = false;
  isTabLoading = false;

  currentEditLat = null;
  currentEditLng = null;
  currentEditZoom = null;

  isCanSubmit = false;
  isCanEditSubmit = true;

  isEditEvent = false;

  currentValve = [];
  currentDisease = [];

  loadMap: boolean = false;
  selectedColor = "";
  startDate: any;
  endDate: any;
  startDate_reformat: any;
  endDate_reformat: any;
  minDate: any;
  hide_enddate = true;
  startTime: any;
  endTime: any;
  minTime: any;
  FormCreateSubmit: FormGroup;
  FormEditSubmit: FormGroup;
  eventId;
  eventDetail: any;
  activityType: any = [];
  workingType: any = [];
  responsiblePerson: any = [];
  status: any = [];
  poleList = [];
  valvesList = [];
  diseaseList = [];

  dropdownPoleSettings = {};
  dropdownValveSettings = {};
  dropdownSettings4 = {};
  imgCreateList = [];
  imgEditList = [];
  imgEditRemoveList = [];
  weatherTypeList = ["1", "2", "3"];
  time_min = [];
  time_sec = [];
  end_time_disabled;
  polygon: any;
  polygons: any[] = [];
  zoom = 18;
  lat: number = 13.764913;
  lng: number = 100.538283;
  allPolygon: any[] = [];
  loadPolygon: boolean = false;

  loadSearchBar: boolean = false;

  isBackSpace = false;

  managerOptions = {
    drawingControl: true,
    drawingControlOptions: {
      drawingModes: ["polygon"],
    },
    polygonOptions: {
      draggable: true,
      editable: true,
      fillColor: "black",
      strokeColor: "black",
      strokeWeight: "2",
    },
    drawingMode: "polygon",
  };

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private eventService: EventService,
    private imageCompress: NgxImageCompressService,
    private cd: ChangeDetectorRef,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) {
    this.FormCreateSubmit = this.fb.group({
      title: [""],
      activity_type: [""],
      working_type: [""],
      start_date: [""],
      end_date: [""],
      start_time: [""],
      end_time: [""],
      poles: [[]],
      valves: [[]],
      remark: [""],
      assign_to: ["", Validators.required],
    });

    this.FormEditSubmit = this.fb.group({
      title: ["", Validators.required],
      activity_type: ["", Validators.required],
      working_type: ["", Validators.required],
      start_date: ["", Validators.required],
      end_date: [""],
      start_time: [""],
      end_time: [""],
      poles: [[]],
      valves: [[]],
      remark: [""],
      status: ["", Validators.required],
      assign_to: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.isEditEvent = false;
    let time = new Date();
    time.setHours(0);
    time.setMinutes(0);
    this.end_time_disabled = time;
    this.FormCreateSubmit.controls.start_time.patchValue(time);

    this.dropdownPoleSettings = {
      singleSelection: false,
      idField: "_id",
      textField: "name",
      selectAllText: "เลือกทั้งหมด",
      unSelectAllText: "เลือกทั้งหมด",
      itemsShowLimit: 0,
      allowSearchFilter: true,
    };
    this.dropdownValveSettings = {
      singleSelection: false,
      idField: "_id",
      textField: "sensor_name",
      selectAllText: "เลือกทั้งหมด",
      unSelectAllText: "เลือกทั้งหมด",
      itemsShowLimit: 0,
      allowSearchFilter: true,
    };
    this.dropdownSettings4 = {
      singleSelection: false,
      idField: "param_id",
      textField: "param_name",
      // selectAllText: 'เลือกทั้งหมด',
      // unSelectAllText: 'เลือกทั้งหมด',
      itemsShowLimit: 0,
      allowSearchFilter: false,
      enableCheckAll: false,
    };

    this.getEvent();
    this.getDataDropdown();
    this.setTime_dropdown();
  }

  initMap(curLat = null, curLng = null, curZoom = null) {
    this.markers = [];

    this.lat = curLat != null ? curLat : this.lat;
    this.lng = curLng != null ? curLng : this.lng;
    this.zoom = curZoom != null ? curZoom : this.zoom;

    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation(curLat, curLng, curZoom);
    });
  }

  changePageEdit() {
    this.pageName = "editEvent";
    this.loadSearchBar = false;
  }

  markerDragEnd(m: marker, $event: MouseEvent) {
    this.markers[0].lat = $event.coords.lat;
    this.markers[0].lng = $event.coords.lng;
  }

  async setCurrentLocation(curLat = null, curLng = null, curZoom = null) {
    try {
      if (!navigator.geolocation) {
        throw new Error("Geolocation is not supported by this browser.");
      }

      let current = await this.getCurrentLocation({
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      });

      this.lat = curLat != null 
        ? curLat
        : parseFloat(current["coords"].latitude.toFixed(6));
      this.lng = curLng != null
        ? curLng
        : parseFloat(current["coords"].longitude.toFixed(6));
      this.zoom = curZoom != null ? curZoom : 18;

    } catch (error) {
      console.log(error)
    }


    this.markers.push({
      lat: curLat != null ? curLat : this.lat,
      lng: curLng != null ? curLng : this.lng,
      draggable: true,
      icon: "assets/img/marker.png",
    });

    this.loadMap = true;
    this.spinner.hide();

    this.reset();
  }

  getCurrentLocation(options) {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resolve,
        ({ code, message }) =>
          reject(
            Object.assign(new Error(message), { name: "PositionError", code })
          ),
        options
      );
    });
  }

  zoomChange(zoom_lv) {
    this.zoom = zoom_lv;
  }

  mapReady(map) {
    map.setOptions({
      zoomControl: "true",
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      draggable: true,
    });

    const search = document.getElementById("search") as HTMLElement;

    map.controls[google.maps.ControlPosition.TOP_LEFT].push(search);

    const input = document.getElementById("search-input") as HTMLInputElement;

    const defaultBounds = {
      north: this.lat + 0.1,
      south: this.lat - 0.1,
      east: this.lng + 0.1,
      west: this.lng - 0.1,
    };

    const options = {
      bounds: defaultBounds,
      componentRestrictions: { country: "th" },
      fields: ["address_components", "geometry", "icon", "name"],
      strictBounds: false,
      types: ["establishment"],
    };

    const autocomplete = new google.maps.places.Autocomplete(input, options);

    // Set initial restriction to the greater list of countries.
    autocomplete.setComponentRestrictions({
      country: ["th"],
    });

    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        //get the place result
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();

        //verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        //set latitude, longitude and zoom
        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();
        this.zoom = 18;

        this.reset();
      });
    });

    setTimeout(() => {
      this.loadSearchBar = true;
      this.reset();
    }, 1000);
  }

  delPolygon() {
    if (this.polygon) {
      this.polygon.setMap(null);
    }

    this.polygons = [];
  }

  polygonCreated($event) {
    if (this.polygon) {
      this.polygon.setMap(null);
    }
    this.polygon = $event;
    this.addPolygonChangeEvent(this.polygon);

    var area = google.maps.geometry.spherical.computeArea(
      this.polygon.getPath()
    );

    // this.form.get('area_size').setValue(area.toFixed(2));

    google.maps.event.addListener(
      this.polygon,
      "coordinates_changed",
      function (index, obj) {
      }
    );
  }

  addPolygonChangeEvent(polygon) {
    var me = polygon,
      isBeingDragged = false,
      triggerCoordinatesChanged = function () {
        google.maps.event.trigger(me, "coordinates_changed");
      };

    google.maps.event.addListener(me, "dragstart", function () {
      isBeingDragged = true;
    });

    google.maps.event.addListener(me, "dragend", function () {
      triggerCoordinatesChanged();
      isBeingDragged = false;
    });

    var paths = me.getPaths();
    this.polygons = [];

    var numberOfPath = polygon.getPath().getLength();

    for (let i = 0; i < numberOfPath; i++) {
      var vertex = polygon.getPath().getAt(i);

      this.polygons.push({
        seq: i + 1,
        lat: vertex.lat(),
        lon: vertex.lng(),
      });
    }

    this.reset();

    paths.forEach(function (path, i) {
      google.maps.event.addListener(path, "insert_at", function () {
        triggerCoordinatesChanged();
      });
      google.maps.event.addListener(path, "set_at", function () {
        if (!isBeingDragged) {
          triggerCoordinatesChanged();
        }
      });
      google.maps.event.addListener(path, "remove_at", function () {
        triggerCoordinatesChanged();
      });
    });
  }

  reset() {
    this.cd.detectChanges();
  }

  setColor(color: string) {
    // this.form.get('color').setValue(color);
    this.selectedColor = color;
    this.managerOptions.polygonOptions.fillColor = color;
    this.managerOptions.polygonOptions.strokeColor = color;
    if (this.polygon) {
      this.polygon.setOptions({
        fillColor: color,
        strokeColor: color,
      });
    }
  }

  reload() {
    this.isTabLoading = false;
    this.spinner.show();
    this.getEvent();
    setTimeout(() => {
      this.isTabLoading = true;
      this.pageName = "calendar";
      //this.spinner.hide();
    }, 200);
  }

  async getEvent() {
    //this.spinner.show();
    this.eventService.getEventList(this.cropId).subscribe((result) => {
      if (result.code == 200) {
        this.INITIAL_EVENTS = result.data;
        //set calendar
        this.calendarOptions = {
          headerToolbar: {
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay", //listWeek
          },
          initialView: "dayGridMonth",
          initialEvents: result.data, // alternatively, use the `events` setting to fetch from a feed
          weekends: true,
          editable: false,
          selectable: true,
          selectMirror: true,
          dayMaxEvents: true, // allow "more" link when too many events
          navLinks: true, // can click day/week names to navigate views
          //select: this.handleDateSelect.bind(this),
          eventClick: this.handleEventClick.bind(this),
          //eventsSet: this.handleEvents.bind(this),
          locale: thLocale,
          nowIndicator: true,
          eventTimeFormat: {
            // like '14:30'
            hour: "2-digit",
            minute: "2-digit",
            meridiem: false,
          },
        };
      }
      //this.spinner.hide();
      //this.tabEvent = true;

      this.isTabLoading = false;
      this.spinner.show();
      setTimeout(() => {
        this.isTabLoading = true;
        this.spinner.hide();
      }, 200);
    });
  }

  async getDataDropdown() {
    this.eventService.getActivityType().subscribe((result) => {
      if (result.code == 200) {
        let activitysort = [];
        for (let index = result.data.length - 1; index >= 0; index--) {
          const element = result.data[index];
          activitysort.push(element);
        }
        this.activityType = activitysort;
      }
      this.spinner.hide();
    });

    this.eventService.getWorkingType().subscribe((result) => {
      if (result.code == 200) {
        this.workingType = result.data;
      }
      this.spinner.hide();
    });

    this.eventService.getResponsiblePerson().subscribe((result) => {
      if (result.code == 200) {
        this.responsiblePerson = result.data;
        // this.responsiblePerson.push({
        //   _id: "60a6264c096b0000350033b3",
        //   display_name: "Chutima Tests",
        // });
      }
      this.spinner.hide();
    });

    this.eventService.getStatus().subscribe((result) => {
      if (result.code == 200) {
        this.status = result.data;
      }
      this.spinner.hide();
    });

    this.eventService.getDisease().subscribe((result) => {
      if (result.code == 200) {
        this.diseaseList = result.data;
      }
      this.spinner.hide();
    });

    this.eventService
      .getAvailableValves(this.plotId)
      .subscribe((result) => {
        this.valvesList = [];
        if (result.code == 200) {
          this.valvesList = result.data;
        }
        this.spinner.hide();
      });
  }

  async getPoles() {
    this.poleList = [];
    let data = {
      working_type: this.FormCreateSubmit.controls.working_type.value
        ? this.FormCreateSubmit.controls.working_type.value
        : this.FormEditSubmit.controls.working_type.value,
      crop_id: this.cropId,
      start_date: this.startDate_reformat,
      end_date: this.endDate_reformat,
    };
    if (
      data.working_type != "" &&
      data.start_date != "" &&
      !(
        data.end_date == "" ||
        data.end_date == null ||
        data.end_date == "1970-01-01"
      )
    ) {
      this.spinner.show();
      this.eventService.getAvailablePoles(data).subscribe((result) => {
        this.FormCreateSubmit.controls.poles.setValue([]);
        if (result.code == 200) {
          this.poleList = result.data;
          this.poleList.sort(function (a, b) {
            if (b.name.localeCompare(a.name)) {
              return 1;
            }
            if (b.name.localeCompare(a.name)) {
              return -1;
            }
            return 0;
          });
        }
        this.spinner.hide();
      });
    }
  }

  handleEventClick(clickInfo: EventClickArg) {
    this.eventId = clickInfo.event.id;
    this.changePage("detailEvent");
    this.activeBtn.nativeElement.click();
    this.getEventDateil();
  }
  refresh() {
    this.pageName = "calendar";
    this.clearOnChangPage();
    this.ngOnInit();
  }
  changePage(value) {
    this.pageName = value;

    if (value == "createEvent") {
      this.initMap();
      this.isCanSubmit = false;
      this.isEditEvent = false;
    }

    this.clearOnChangPage();
  }

  setTime_dropdown() {
    this.time_min = [];
    for (let index = 1; index <= 59; index++) {
      const zeroPad = (num, places) => String(num).padStart(places, "0");
      this.time_min.push({
        param_id: zeroPad(index, 2),
        param_name: zeroPad(index, 2),
      });
    }
    this.time_sec = [];
    for (let index = 0; index <= 59; index++) {
      const zeroPad = (num, places) => String(num).padStart(places, "0");
      this.time_sec.push({
        param_id: zeroPad(index, 2),
        param_name: zeroPad(index, 2),
      });
    }
  }

  dateFormat(date) {
    var datenow = new Date(date);
    return moment
      .utc(datenow, "YYYY-MM-DD HH:mm:ss")
      .format("DD/MM/YYYY HH:mm");
  }

  convertDateToUTC(date) {
    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    );
  }

  clearOnChangPage() {
    this.startDate = "";
    (this.endDate = ""), (this.startDate_reformat = "");
    this.endDate_reformat = "";
    this.minTime = "";
    let time = new Date();
    time.setHours(0);
    time.setMinutes(0);
    this.startTime = time;
    this.endTime = time;
    this.currentEditLat = null;
    this.currentEditLng = null;
    this.currentEditZoom = null;
    this.markers = [];

    // this.FormCreateSubmit.controls.start_time.patchValue(time);
    // this.FormCreateSubmit.controls.end_time.patchValue(time);

    this.FormCreateSubmit.controls.title.patchValue("");
    this.FormCreateSubmit.controls.activity_type.patchValue("");
    this.FormCreateSubmit.controls.working_type.patchValue("");
    this.FormCreateSubmit.controls.start_date.patchValue("");
    this.FormCreateSubmit.controls.start_time.patchValue("");
    this.FormCreateSubmit.controls.end_date.patchValue("");
    this.FormCreateSubmit.controls.end_time.patchValue("");
    this.FormCreateSubmit.controls.poles.patchValue([]);
    this.FormCreateSubmit.controls.valves.patchValue([]);
    this.FormCreateSubmit.controls.remark.patchValue("");
    this.FormCreateSubmit.controls.assign_to.patchValue("");

    this.clearFormControl(this.FormCreateSubmit, "fertilize")
    this.clearFormControl(this.FormCreateSubmit, "water")
    this.clearFormControl(this.FormCreateSubmit, "spray")
    this.clearFormControl(this.FormCreateSubmit, "disease")
    this.clearFormControl(this.FormCreateSubmit, "weather")
    this.clearFormControl(this.FormCreateSubmit, "soil_quality")
    this.clearFormControl(this.FormCreateSubmit, "stem_quality")

    //comment

    this.FormEditSubmit.controls.title.patchValue("");
    this.FormEditSubmit.controls.activity_type.patchValue("");
    this.FormEditSubmit.controls.working_type.patchValue("");
    this.FormEditSubmit.controls.start_date.patchValue("");
    this.FormEditSubmit.controls.end_date.patchValue("");
    this.FormEditSubmit.controls.poles.patchValue([]);
    this.FormEditSubmit.controls.valves.patchValue([]);
    this.FormEditSubmit.controls.remark.patchValue("");
    this.FormEditSubmit.controls.status.patchValue("");
    this.FormEditSubmit.controls.assign_to.patchValue("");

    this.clearFormControl(this.FormEditSubmit, "fertilize")
    this.clearFormControl(this.FormEditSubmit, "water")
    this.clearFormControl(this.FormEditSubmit, "spray")
    this.clearFormControl(this.FormEditSubmit, "disease")
    this.clearFormControl(this.FormEditSubmit, "weather")
    this.clearFormControl(this.FormEditSubmit, "soil_quality")
    this.clearFormControl(this.FormEditSubmit, "stem_quality")

    this.minDate = null;
    this.imgCreateList = [];
    this.imgEditList = [];
    this.imgEditRemoveList = [];
  }

  clearFormControl(SubmitForm, activity_type) {
    if (activity_type == "fertilize") {
      SubmitForm.removeControl("fertilizerBrand");
      SubmitForm.removeControl("fertilizerFormula");
      SubmitForm.removeControl("fertilizerVolume");
      SubmitForm.removeControl("fertilizerCost");
    }
    
    if (activity_type == "water") {
      SubmitForm.removeControl("waterTime_min");
      SubmitForm.removeControl("waterTime_sec");
      // SubmitForm.removeControl("waterVolume");
    }
    
    if (activity_type == "spray") {
      SubmitForm.removeControl("sprayBrand");
      SubmitForm.removeControl("sprayFormula");
      SubmitForm.removeControl("sprayVolume");
      SubmitForm.removeControl("sprayCost");
    }

    if (activity_type == "disease") {
      // SubmitForm.removeControl("disease");
      SubmitForm.removeControl("diseasePosition");
    }

    if (activity_type == "weather") {
      SubmitForm.removeControl("sunlightType");
      SubmitForm.removeControl("windType");
      SubmitForm.removeControl("rainType");
    }

    if (activity_type == "soil_quality") {
      SubmitForm.removeControl("humidity");
      SubmitForm.removeControl("temperature");
      SubmitForm.removeControl("ph");
      SubmitForm.removeControl("ec");
      SubmitForm.removeControl("npk");
      SubmitForm.removeControl("soil_conditions");
    }

    if (activity_type == "stem_quality") {
      SubmitForm.removeControl("leftMoisture1");
      SubmitForm.removeControl("leftMoisture2");
      SubmitForm.removeControl("leftMoisture3");
      SubmitForm.removeControl("leftMoisture4");
      SubmitForm.removeControl("leftMoistureAvg");
      SubmitForm.removeControl("stemHealth");
      SubmitForm.removeControl("leafHealth");
      SubmitForm.removeControl("flowerHealth");
      SubmitForm.removeControl("fruitHealth");
    }
  }

  selectstartDate(startdate) {
    if (startdate) {
      this.minDate = new Date(startdate);
      this.startDate = startdate;
      // this.FormCreateSubmit.controls.end_date.patchValue("")
      this.hide_enddate = false;
      this.startDate_reformat = moment(
        new Date(this.startDate),
        "DD/MM/YYYY",
        "Asia/Bangkok"
      ).format("YYYY-MM-DD");

      if (
        !this.endDate ||
        new Date(this.startDate).getTime() > new Date(this.endDate).getTime()
      ) {
        this.endDate_reformat = moment(
          new Date(this.startDate),
          "YYYY-MM-DD HH:mm:ss",
          "Asia/Bangkok"
        ).format("YYYY-MM-DD");
        if(new Date(this.startDate).getTime() > new Date(this.endDate).getTime()){
          this.endDate = new Date(this.startDate);
        }
        // 
        this.FormCreateSubmit.controls.end_date.setValue(this.startDate);
      }
      // }
      let endtime = new Date(this.endTime);
      // endtime.setHours(0);
      // endtime.setMinutes(0);
      this.FormCreateSubmit.controls.end_time.patchValue(endtime);
      this.endTime = endtime;
      // this.getPoles();
    } else {
      this.hide_enddate = true;
    }
    
    if (this.isEditEvent) {
      this.validateEditAll();
    } else {
      this.validateAll();
    }
  }

  selectendDate(endDate) {
    if (endDate) {
      this.endDate_reformat = moment(
        new Date(this.endDate),
        "YYYY-MM-DD HH:mm:ss",
        "Asia/Bangkok"
      ).format("YYYY-MM-DD");
      if (this.endDate_reformat == this.startDate_reformat) {
        let starttime = new Date(this.startTime);
        starttime.setMinutes(starttime.getMinutes() + 1);
        if (starttime.getHours() > new Date(this.endTime).getHours()) {
          this.endTime = starttime;
        }
        let setminTime = new Date(starttime);
        setminTime.setMinutes(starttime.getMinutes() - 1);
        this.minTime = setminTime;
      } else {
        this.minTime = "";
      }
      // this.getPoles();
    }
  }

  start_time_changed() {
    if (this.endDate_reformat == this.startDate_reformat) {
      let time = new Date(this.startTime);
      let etime = new Date(this.endTime);
      let startDate = time.getDate();
      let endDate = etime.getDate();

      if (this.startTime >= this.endTime) {
        let dateLoop = time.getMinutes() == 59 && time.getHours() == 23 && etime.getMinutes() == 1 && etime.getHours() == 23;

        if(dateLoop){
          time.setDate(time.getDate() - 1);
          time.setMinutes(time.getMinutes() + 1);
   
          this.endTime = time;
        }else{
          time.setMinutes(time.getMinutes() + 1);
          this.endTime = time;
        }

      } else if (endDate > startDate) {
        let dateLoop = time.getMinutes() == 59 && time.getHours() == 23 && etime.getMinutes() == 0 && etime.getHours() == 0;
        if(!dateLoop){
          this.endTime = this.startTime;
          time.setMinutes(time.getMinutes() + 1);
          this.endTime = time;
        }

      }
      let setminTime = new Date(time);
      setminTime.setMinutes(time.getMinutes() - 1);

      this.minTime = setminTime;
    }
  }
  end_time_changed() {
  }

  onDiseaseItemDeSelect(item: any) {
    if (!this.isEditEvent) {
      this.validateAll();
    } else {
      this.validateEditAll();
    }
  }

  onDiseaseItemSelect(item: any) {
    if (!this.isEditEvent) {
      this.validateAll();
    } else {
      this.validateEditAll();
    }
  }

  onItemSelect(item: any) {
    const isFounded = this.currentValve.find((fitem) => {
      return item._id == fitem._id;
    });

    if (!isFounded) this.currentValve.push(item);

    if (!this.isEditEvent) {
      this.validateAll();
    } else {
      this.validateEditAll();
    }

  }
  onSelectAll(items: any) {
    this.currentValve = items;
    if (!this.isEditEvent) {
      this.validateAll();
    } else {
      this.validateEditAll();
    }
  }

  onItemDeSelect(item: any) {
    const isFoundedIdx = this.currentValve.findIndex((fitem) => {
      return item._id == fitem._id;
    });

    if (isFoundedIdx != -1) this.currentValve.splice(isFoundedIdx, 1);

    if (!this.isEditEvent) {
      this.validateAll();
    } else {
      this.validateEditAll();
    }
  }

  onItemDeSelectAll(items: any) {
    this.currentValve = [];

    if (!this.isEditEvent) {
      this.validateAll();
    } else {
      this.validateEditAll();
    }
  }

  //  ================================================================ Start CreateEvent ================================================================

  changeActivityTypeCreate(event) {
    this.isCanSubmit = false;
    this.spinner.show();
    // dynamic add control
    if (this.FormCreateSubmit.controls.activity_type.value == "fertilize") {
      this.FormCreateSubmit.addControl(
        "fertilizerBrand",
        new FormControl("", Validators.required)
      );
      this.FormCreateSubmit.addControl(
        "fertilizerFormula",
        new FormControl("", Validators.required)
      );
      this.FormCreateSubmit.addControl(
        "fertilizerVolume",
        new FormControl("", Validators.required)
      );
      this.FormCreateSubmit.addControl(
        "fertilizerCost",
        new FormControl("", Validators.required)
      );

      this.FormCreateSubmit.controls["fertilizerFormula"].valueChanges
        .pipe(pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          const replacePrev = prev.replaceAll("-", "");
          const replaceNext = next.replaceAll("-", "");
          if (replacePrev.length < replaceNext.length) {
            if (!this.isBackSpace) {
              if (replacePrev.length == 1 || replacePrev.length == 3) {
                this.FormCreateSubmit.controls["fertilizerFormula"].setValue(
                  this.FormCreateSubmit.controls["fertilizerFormula"].value +
                    "-",
                  {
                    emitEvent: false,
                  }
                );
                this.isBackSpace = false;
              }
            } else {
              if (replacePrev.length == 2) {

                this.FormCreateSubmit.controls["fertilizerFormula"].setValue(
                  this.FormCreateSubmit.controls[
                    "fertilizerFormula"
                  ].value.substring(0, 2) +
                    "-" +
                    replaceNext.substring(2),
                  {
                    emitEvent: false,
                  }
                );
                this.isBackSpace = false;
              } else if (replacePrev.length == 4) {

                this.FormCreateSubmit.controls["fertilizerFormula"].setValue(
                  this.FormCreateSubmit.controls[
                    "fertilizerFormula"
                  ].value.substring(0, 5) +
                    "-" +
                    replaceNext.substring(4),
                  {
                    emitEvent: false,
                  }
                );
                this.isBackSpace = false;
              }
            }
          }

          if (replacePrev.length > replaceNext.length) {
            if (replacePrev.length == 3) {
              this.FormCreateSubmit.controls["fertilizerFormula"].setValue(
                this.FormCreateSubmit.controls[
                  "fertilizerFormula"
                ].value.substring(
                  0,
                  this.FormCreateSubmit.controls["fertilizerFormula"].value
                    .length - 1
                ),
                {
                  emitEvent: false,
                }
              );
              this.isBackSpace = true;
            }

            if (replacePrev.length == 5) {
              this.FormCreateSubmit.controls["fertilizerFormula"].setValue(
                this.FormCreateSubmit.controls[
                  "fertilizerFormula"
                ].value.substring(
                  0,
                  this.FormCreateSubmit.controls["fertilizerFormula"].value
                    .length - 1
                ),
                {
                  emitEvent: false,
                }
              );
              this.isBackSpace = true;
            }
          }
        });

      this.FormCreateSubmit.controls["fertilizerVolume"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["fertilizerVolume"].setValue(
              Number(
                this.FormCreateSubmit.controls["fertilizerVolume"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormCreateSubmit.controls["fertilizerCost"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["fertilizerCost"].setValue(
              Number(
                this.FormCreateSubmit.controls["fertilizerCost"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

        this.clearFormControl(this.FormCreateSubmit, "water");
        this.clearFormControl(this.FormCreateSubmit, "spray");
        this.clearFormControl(this.FormCreateSubmit, "disease");
        this.clearFormControl(this.FormCreateSubmit, "weather");
        this.clearFormControl(this.FormCreateSubmit, "soil_quality");
        this.clearFormControl(this.FormCreateSubmit, "stem_quality");

    } else if (this.FormCreateSubmit.controls.activity_type.value == "water") {
      this.currentValve = [];
      this.FormCreateSubmit.addControl(
        "waterTime_min",
        new FormControl("", Validators.required)
      );
      this.FormCreateSubmit.addControl(
        "waterTime_sec",
        new FormControl("", Validators.required)
      );
      // this.FormCreateSubmit.addControl(
      //   "waterVolume",
      //   new FormControl("", Validators.required)
      // );

      this.clearFormControl(this.FormCreateSubmit, "fertilize");
      this.clearFormControl(this.FormCreateSubmit, "spray");
      this.clearFormControl(this.FormCreateSubmit, "disease");
      this.clearFormControl(this.FormCreateSubmit, "weather");
      this.clearFormControl(this.FormCreateSubmit, "soil_quality");
      this.clearFormControl(this.FormCreateSubmit, "stem_quality");

    } else if (this.FormCreateSubmit.controls.activity_type.value == "spray") {
      this.FormCreateSubmit.addControl(
        "sprayBrand",
        new FormControl("", Validators.required)
      );
      this.FormCreateSubmit.addControl(
        "sprayFormula",
        new FormControl("", Validators.required)
      );
      this.FormCreateSubmit.addControl(
        "sprayVolume",
        new FormControl("", Validators.required)
      );
      this.FormCreateSubmit.addControl(
        "sprayCost",
        new FormControl("", Validators.required)
      );

      this.FormCreateSubmit.controls["sprayVolume"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["sprayVolume"].setValue(
              Number(
                this.FormCreateSubmit.controls["sprayVolume"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormCreateSubmit.controls["sprayCost"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["sprayCost"].setValue(
              Number(this.FormCreateSubmit.controls["sprayCost"].value).toFixed(
                2
              ),
              {
                emitEvent: false,
              }
            );
          }
        });


        this.clearFormControl(this.FormCreateSubmit, "fertilize");
        this.clearFormControl(this.FormCreateSubmit, "water");
        this.clearFormControl(this.FormCreateSubmit, "disease");
        this.clearFormControl(this.FormCreateSubmit, "weather");
        this.clearFormControl(this.FormCreateSubmit, "soil_quality");
        this.clearFormControl(this.FormCreateSubmit, "stem_quality");

    } else if (
      this.FormCreateSubmit.controls.activity_type.value == "disease"
    ) {
      this.loadSearchBar = false;
      this.FormCreateSubmit.addControl(
        "disease",
        new FormControl([], Validators.required)
      );

      this.FormCreateSubmit.addControl(
        "diseasePosition",
        new FormControl("", Validators.required)
      );

      this.clearFormControl(this.FormCreateSubmit, "fertilize");
      this.clearFormControl(this.FormCreateSubmit, "water");
      this.clearFormControl(this.FormCreateSubmit, "spray");
      this.clearFormControl(this.FormCreateSubmit, "weather");
      this.clearFormControl(this.FormCreateSubmit, "soil_quality");
      this.clearFormControl(this.FormCreateSubmit, "stem_quality");

    } else if (
      this.FormCreateSubmit.controls.activity_type.value == "weather"
    ) {
      this.FormCreateSubmit.addControl("sunlightType", new FormControl([""]));
      this.FormCreateSubmit.addControl("windType", new FormControl([""]));
      this.FormCreateSubmit.addControl("rainType", new FormControl([""]));
      
      this.clearFormControl(this.FormCreateSubmit, "fertilize");
      this.clearFormControl(this.FormCreateSubmit, "water");
      this.clearFormControl(this.FormCreateSubmit, "spray");
      this.clearFormControl(this.FormCreateSubmit, "disease");
      this.clearFormControl(this.FormCreateSubmit, "soil_quality");
      this.clearFormControl(this.FormCreateSubmit, "stem_quality");

    } else if (
      this.FormCreateSubmit.controls.activity_type.value == "soil_quality"
    ) {
      this.loadSearchBar = false;
      
      this.FormCreateSubmit.addControl("humidity", new FormControl([""]));
      this.FormCreateSubmit.addControl("temperature", new FormControl([""]));
      this.FormCreateSubmit.addControl("ph", new FormControl([""]));
      this.FormCreateSubmit.addControl("ec", new FormControl([""]));
      this.FormCreateSubmit.addControl("npk", new FormControl([""]));
      this.FormCreateSubmit.addControl("soil_conditions", new FormControl([""]));

      this.FormCreateSubmit.controls["humidity"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["humidity"].setValue(
              Number(this.FormCreateSubmit.controls["humidity"].value).toFixed(
                2
              ),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormCreateSubmit.controls["temperature"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["temperature"].setValue(
              Number(
                this.FormCreateSubmit.controls["temperature"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormCreateSubmit.controls["ph"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["ph"].setValue(
              Number(this.FormCreateSubmit.controls["ph"].value).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormCreateSubmit.controls["ec"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["ec"].setValue(
              Number(this.FormCreateSubmit.controls["ec"].value).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormCreateSubmit.controls["npk"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["npk"].setValue(
              Number(this.FormCreateSubmit.controls["npk"].value).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.clearFormControl(this.FormCreateSubmit, "fertilize");
      this.clearFormControl(this.FormCreateSubmit, "water");
      this.clearFormControl(this.FormCreateSubmit, "spray");
      this.clearFormControl(this.FormCreateSubmit, "disease");
      this.clearFormControl(this.FormCreateSubmit, "weather");
      this.clearFormControl(this.FormCreateSubmit, "stem_quality");

    }
    else if (
      this.FormCreateSubmit.controls.activity_type.value == "stem_quality"
    ) {
      this.loadSearchBar = false;

      this.FormCreateSubmit.addControl("leftMoisture1", new FormControl([""]));
      this.FormCreateSubmit.addControl("leftMoisture2", new FormControl([""]));
      this.FormCreateSubmit.addControl("leftMoisture3", new FormControl([""]));
      this.FormCreateSubmit.addControl("leftMoisture4", new FormControl([""]));
      this.FormCreateSubmit.addControl("leftMoistureAvg", new FormControl([""]));

      this.FormCreateSubmit.controls["leftMoisture1"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["leftMoisture1"].setValue(
              Number(
                this.FormCreateSubmit.controls["leftMoisture1"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormCreateSubmit.controls["leftMoisture2"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["leftMoisture2"].setValue(
              Number(
                this.FormCreateSubmit.controls["leftMoisture2"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormCreateSubmit.controls["leftMoisture3"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["leftMoisture3"].setValue(
              Number(
                this.FormCreateSubmit.controls["leftMoisture3"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormCreateSubmit.controls["leftMoisture4"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormCreateSubmit.controls["leftMoisture4"].setValue(
              Number(
                this.FormCreateSubmit.controls["leftMoisture4"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormCreateSubmit.addControl("stemHealth", new FormControl([""]));
      this.FormCreateSubmit.addControl("leafHealth", new FormControl([""]));
      this.FormCreateSubmit.addControl("flowerHealth", new FormControl([""]));
      this.FormCreateSubmit.addControl("fruitHealth", new FormControl([""]));

      this.clearFormControl(this.FormCreateSubmit, "fertilize");
      this.clearFormControl(this.FormCreateSubmit, "water");
      this.clearFormControl(this.FormCreateSubmit, "spray");
      this.clearFormControl(this.FormCreateSubmit, "disease");
      this.clearFormControl(this.FormCreateSubmit, "weather");
      this.clearFormControl(this.FormCreateSubmit, "soil_quality");

    } else if (
      this.FormCreateSubmit.controls.activity_type.value == "store_pictures"
    ) {
      this.loadSearchBar = false;

      this.clearFormControl(this.FormCreateSubmit, "fertilize");
      this.clearFormControl(this.FormCreateSubmit, "water");
      this.clearFormControl(this.FormCreateSubmit, "spray");
      this.clearFormControl(this.FormCreateSubmit, "disease");
      this.clearFormControl(this.FormCreateSubmit, "weather");
      this.clearFormControl(this.FormCreateSubmit, "soil_quality");
      this.clearFormControl(this.FormCreateSubmit, "stem_quality");


      this.FormCreateSubmit.removeControl("diseasePosition");
    }

    if (this.isEditEvent) {
      this.validateEditAll();
    } else {
      this.validateAll();
    }

    setTimeout(() => {
      this.spinner.hide();
    }, 200);
  }

  changeWorkType(event) {
    if (this.isEditEvent) {
      this.validateEditAll();
    } else {
      this.validateAll();
    }
  }

  openImgUpload() {
    $("#imgupload").trigger("click");
  }

  // upload file
  public async fileChangeEvent(eventUpload: any, type) {
    if (
      eventUpload.target.files[0].type == "image/png" ||
      eventUpload.target.files[0].type == "image/jpeg" ||
      eventUpload.target.files[0].type == "image/jpg"
    ) {
      // var size = (eventUpload.target.files[0].size / Math.pow(1024, 2)).toFixed(2);
      if (eventUpload) {
        this.spinner.show();
        this.readFileAsync(eventUpload.target.files[0]).then(
          (compressImage: any) => {
            if (type == "create") {
              this.imgCreateList.push({
                url: compressImage.base64,
                file: compressImage.file,
              });
              this.validateAll();
            }
            if (type == "edit") {
              this.imgEditList.push({
                url: compressImage.base64,
                file: compressImage.file,
                type: "new",
              });
              this.validateEditAll();
            }
            this.spinner.hide();
          }
        );
      }
    } else {
    }
  }

  // convert file to base64
  async readFileAsync(Image) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(Image);
      reader.onload = (event: any) => {
        this.compressFile(event.target.result, Image).then(
          (resBase64Compress) => {
            resolve(resBase64Compress);
          }
        );
      };
    });
  }

  // compressFile
  async compressFile(base64, Image) {
    let ratio = 40,
      quality = 70;
    let byteCompress;
    //console.warn('Size in bytes was:', Image.size);
    if (Image.size <= 500000) {
      //console.warn('Size Of file < 500000:', Image.size);
      return { base64: base64, file: Image };
    } else {
      do {
        byteCompress = await this.imageCompress
          .compressFile(base64, -1, ratio, quality)
          .then((result) => {
            let fileCompress = this.dataURLtoFile(result, Image.name);
            //console.warn('Size in bytes is now:', fileCompress.size);
            return { base64: result, file: fileCompress };
          });
        ratio = ratio - 5;
      } while (byteCompress.file.size > 500000);

      return byteCompress;
    }
  }

  // convert base64 to file
  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  removeImage_Create(index) {
    this.imgCreateList.splice(index, 1);
    this.validateAll();
  }

  chkConfirmCreateSubmit() {

    if (!this.isCanSubmit) return;

    if (true) {
      const formData = new FormData();
      formData.append("title", this.FormCreateSubmit.controls.title.value);
      formData.append("zone_id", this.zoneId);
      formData.append("plot_id", this.plotId);
      formData.append("crop_id", this.cropId);
      formData.append(
        "activity_type",
        this.FormCreateSubmit.controls.activity_type.value == ""
          ? null
          : this.FormCreateSubmit.controls.activity_type.value
      );
      formData.append(
        "working_type",
        this.FormCreateSubmit.controls.working_type.value == ""
          ? null
          : this.FormCreateSubmit.controls.working_type.value
      );
      let start_time = new Date(this.startTime);
      let end_time = new Date(this.endTime);
      const zeroPad = (num, places) => String(num).padStart(places, "0");
      formData.append(
        "start_date",
        this.startDate_reformat +
          " " +
          zeroPad(start_time.getHours(), 2) +
          ":" +
          zeroPad(start_time.getMinutes(), 2)
      );
      formData.append(
        "end_date",
        this.endDate_reformat +
          " " +
          zeroPad(end_time.getHours(), 2) +
          ":" +
          zeroPad(end_time.getMinutes(), 2)
      );
      formData.append(
        "poles",
        this.FormCreateSubmit.controls.poles.value.length == 0
          ? null
          : JSON.stringify(this.FormCreateSubmit.controls.poles.value)
      ); //

      let valveFull = this.FormCreateSubmit.controls.valves.value.map((x) => {
        let valve = this.valvesList.find((y) => y._id === x._id);
        return valve;
      });
      formData.append(
        "valves",
        valveFull.length == 0 ? null : JSON.stringify(valveFull)
      );

      formData.append(
        "fertilize",
        this.FormCreateSubmit.controls.activity_type.value == "fertilize"
          ? JSON.stringify({
              brand:
                this.FormCreateSubmit.controls.fertilizerBrand.value == ""
                  ? null
                  : this.FormCreateSubmit.controls.fertilizerBrand.value,
              formula:
                this.FormCreateSubmit.controls.fertilizerFormula.value == ""
                  ? null
                  : this.FormCreateSubmit.controls.fertilizerFormula.value,
              volume:
                this.FormCreateSubmit.controls.fertilizerVolume.value == ""
                  ? null
                  : this.FormCreateSubmit.controls.fertilizerVolume.value,
              cost:
                this.FormCreateSubmit.controls.fertilizerCost.value == ""
                  ? null
                  : this.FormCreateSubmit.controls.fertilizerCost.value,
            })
          : null
      );
      formData.append(
        "water",
        this.FormCreateSubmit.controls.activity_type.value == "water"
          ? JSON.stringify({
              time_min: 
                this.FormCreateSubmit.controls.waterTime_min.value != ""
                  ? this.FormCreateSubmit.controls.waterTime_min.value
                  : null,
              time_sec:
                this.FormCreateSubmit.controls.waterTime_sec.value != ""
                  ? this.FormCreateSubmit.controls.waterTime_sec.value
                  : null,
              // volume: this.FormCreateSubmit.controls.waterVolume.value,
            })
          : null
      );
      formData.append(
        "spray",
        this.FormCreateSubmit.controls.activity_type.value == "spray"
          ? JSON.stringify({
              brand:
                this.FormCreateSubmit.controls.sprayBrand.value == ""
                  ? null
                  : this.FormCreateSubmit.controls.sprayBrand.value,
              formula:
                this.FormCreateSubmit.controls.sprayFormula.value == ""
                  ? null
                  : this.FormCreateSubmit.controls.sprayFormula.value,
              volume: 
                this.FormCreateSubmit.controls.sprayVolume.value == ""
                  ? null
                  : this.FormCreateSubmit.controls.sprayVolume.value,
              cost:
                this.FormCreateSubmit.controls.sprayCost.value == ""
                  ? null
                  : this.FormCreateSubmit.controls.sprayCost.value,
            })
          : null
      );

      // formData.append(
      //   "disease_position",
      //   this.FormCreateSubmit.controls.activity_type.value == "disease"
      //     ? this.FormCreateSubmit.controls.diseasePosition.value == ""
      //       ? null
      //       : this.FormCreateSubmit.controls.diseasePosition.value
      //     : null
      // );

      formData.append(
        "disease",
        this.FormCreateSubmit.controls.activity_type.value == "disease"
          ? JSON.stringify(this.FormCreateSubmit.controls.disease.value)
          : null
      );

      formData.append(
        "disease_position",
        this.FormCreateSubmit.controls.activity_type.value == "disease"
          ? this.FormCreateSubmit.controls.diseasePosition.value == ""
            ? null
            : this.FormCreateSubmit.controls.diseasePosition.value
          : null
      );

      formData.append(
        "weather",
        this.FormCreateSubmit.controls.activity_type.value == "weather"
          ? JSON.stringify({
              sunlight_conditions:
                this.FormCreateSubmit.controls.sunlightType.value != ""
                  ? this.FormCreateSubmit.controls.sunlightType.value
                  : null,
              wind_strength:
                this.FormCreateSubmit.controls.windType.value != ""
                  ? this.FormCreateSubmit.controls.windType.value
                  : null,
              rainy_weather:
                this.FormCreateSubmit.controls.rainType.value != ""
                  ? this.FormCreateSubmit.controls.rainType.value
                  : null,
            })
          : null
      );

      formData.append(
        "soil_quality",
        this.FormCreateSubmit.controls.activity_type.value == "soil_quality"
          ? JSON.stringify({
              humidity:
                this.FormCreateSubmit.controls.humidity.value != ""
                  ? this.FormCreateSubmit.controls.humidity.value
                  : null,
              temperature:
                this.FormCreateSubmit.controls.temperature.value != ""
                  ? this.FormCreateSubmit.controls.temperature.value
                  : null,
              ph:
                this.FormCreateSubmit.controls.ph.value != ""
                  ? this.FormCreateSubmit.controls.ph.value
                  : null,
              ec:
                this.FormCreateSubmit.controls.ec.value != ""
                  ? this.FormCreateSubmit.controls.ec.value
                  : null,
              npk:
                this.FormCreateSubmit.controls.npk.value != ""
                  ? this.FormCreateSubmit.controls.npk.value
                  : null,
              soil_conditions:
                this.FormCreateSubmit.controls.soil_conditions.value == ""
                  ? null
                  : this.FormCreateSubmit.controls.soil_conditions.value,
            })
          : null
      );

      formData.append(
        "stem_quality",
        this.FormCreateSubmit.controls.activity_type.value == "stem_quality"
          ? JSON.stringify({
              leaf_moisture_1:
                this.FormCreateSubmit.controls.leftMoisture1.value != ""
                  ? this.FormCreateSubmit.controls.leftMoisture1.value
                  : null,
              leaf_moisture_2:
                this.FormCreateSubmit.controls.leftMoisture2.value != ""
                  ? this.FormCreateSubmit.controls.leftMoisture2.value
                  : null,
              leaf_moisture_3:
                this.FormCreateSubmit.controls.leftMoisture3.value != ""
                  ? this.FormCreateSubmit.controls.leftMoisture3.value
                  : null,
              leaf_moisture_4:
                this.FormCreateSubmit.controls.leftMoisture4.value != ""
                  ? this.FormCreateSubmit.controls.leftMoisture4.value
                  : null,
              leaf_moisture_avg:
                this.FormCreateSubmit.controls.leftMoistureAvg.value != ""
                  ? this.FormCreateSubmit.controls.leftMoistureAvg.value
                  : null,

              stem_health:
                this.FormCreateSubmit.controls.stemHealth.value != ""
                  ? this.FormCreateSubmit.controls.stemHealth.value
                  : null,
              leaf_health:
                this.FormCreateSubmit.controls.leafHealth.value != ""
                  ? this.FormCreateSubmit.controls.leafHealth.value
                  : null,
              flower_health:
                this.FormCreateSubmit.controls.flowerHealth.value != ""
                  ? this.FormCreateSubmit.controls.flowerHealth.value
                  : null,
              fruit_health:
                this.FormCreateSubmit.controls.fruitHealth.value != ""
                  ? this.FormCreateSubmit.controls.fruitHealth.value
                  : null,
            })
          : null
      );

      formData.append(
        "coordinates",
        this.FormCreateSubmit.controls.activity_type.value == "soil_quality" ||
        this.FormCreateSubmit.controls.activity_type.value == "stem_quality" ||
        this.FormCreateSubmit.controls.activity_type.value == "disease"
          ? JSON.stringify({
              center: {
                lat: this.markers[0].lat,
                lon: this.markers[0].lng,
                zoom_lv: this.zoom,
              },
            })
          : null
      );

      formData.append("remark", this.FormCreateSubmit.controls.remark.value);
      formData.append(
        "assign_to",
        this.FormCreateSubmit.controls.assign_to.value == ""
          ? null
          : this.FormCreateSubmit.controls.assign_to.value.toString()
      );

      for (let index = 0; index < this.imgCreateList.length; index++) {
        const element = this.imgCreateList[index];
        let i = Number(index) + 1;
        formData.append("pic_" + i.toString(), element.file);
      }

      this.spinner.show();
      this.eventService.addEvent(formData).subscribe((result) => {
        if (result.code == 200) {
          $("#eventCreaeSuccessmodal").modal("show");
        }
        this.spinner.hide();
      });
    } else {
      $("#eventCreaeFailmodal").modal("show");
    }
  }
  //  ================================================================= End CreateEvent =================================================================

  //  ================================================================ Start DetailEvent ================================================================
  async getEventDateil() {
    this.spinner.show();

    this.loading = true; // on load data success

    this.eventService.getEventById(this.eventId).subscribe((result) => {
      this.isEditEvent = true;
      this.currentValve = [];
      if (result.code == 200) {
        this.eventDetail = result.data;

        if (this.eventDetail.assign_to) {
          this.eventDetail["assign_to"] = this.responsiblePerson.find(
            (x) => x._id == this.eventDetail["assign_to"]
          );
        }
        if (this.eventDetail.activity_type) {
          this.eventDetail["activity_type"] = this.activityType.find(
            (x) => x.param_id == this.eventDetail["activity_type"]
          );
        }
        if (this.eventDetail.working_type) {
          this.eventDetail["working_type"] = this.workingType.find(
            (x) => x.param_id == this.eventDetail["working_type"]
          );
        }
        
        this.eventDetail["status"] = this.status.find(
          (x) => x.param_id == this.eventDetail["status"]
        );
        this.formEdit_patchvalue();
      }
      this.spinner.hide();
    });
  }

  formEdit_patchvalue() {

    this.imgEditList = [];
    this.imgEditRemoveList = [];

    this.FormEditSubmit.controls.title.patchValue(this.eventDetail.title);
    this.FormEditSubmit.controls.activity_type.patchValue(
        this.eventDetail.activity_type ? this.eventDetail.activity_type.param_id : ""
    );
    this.FormEditSubmit.controls.working_type.patchValue(
      this.eventDetail.working_type ? this.eventDetail.working_type.param_id : ""
    );
    this.FormEditSubmit.controls.start_date.patchValue(
      this.dateFormat(this.eventDetail.start_date)
    );
    this.FormEditSubmit.controls.end_date.patchValue(
      this.dateFormat(this.eventDetail.end_date)
    );

    this.startTime = this.convertDateToUTC(
      new Date(this.eventDetail.start_date)
    );
    this.endTime = this.convertDateToUTC(new Date(this.eventDetail.end_date));

    this.FormEditSubmit.controls.poles.patchValue(
      this.eventDetail.poles == null ? [] : this.eventDetail.poles
    );
    this.FormEditSubmit.controls.valves.patchValue(
      this.eventDetail.valves == null ? [] : this.eventDetail.valves
    );
    this.FormEditSubmit.controls.remark.patchValue(this.eventDetail.remark);
    this.FormEditSubmit.controls.status.patchValue(
      this.eventDetail.status.param_id
    );
    this.FormEditSubmit.controls.assign_to.patchValue(
      this.eventDetail.assign_to ? this.eventDetail.assign_to._id : ""
    );

    this.changeActivityTypeEdit()
  }

  changeActivityTypeEdit(event?){
    if (this.FormEditSubmit.controls.activity_type.value == "fertilize") {
      if (!this.eventDetail.fertilize) this.eventDetail.fertilize = {};

      this.FormEditSubmit.addControl(
        "fertilizerBrand",
        new FormControl(
          this.eventDetail.fertilize.brand ? this.eventDetail.fertilize.brand : null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "fertilizerFormula",
        new FormControl(
          this.eventDetail.fertilize.formula ? this.eventDetail.fertilize.formula : null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "fertilizerVolume",
        new FormControl(
          this.eventDetail.fertilize.volume ? this.eventDetail.fertilize.volume : null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "fertilizerCost",
        new FormControl(
          this.eventDetail.fertilize.cost ? this.eventDetail.fertilize.cost : null,
          Validators.required
        )
      );

      this.FormEditSubmit.controls["fertilizerFormula"].valueChanges
        .pipe(pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          const replacePrev = prev.replaceAll("-", "");
          const replaceNext = next.replaceAll("-", "");
          if (replacePrev.length < replaceNext.length) {
            if (!this.isBackSpace) {
              if (replacePrev.length == 1 || replacePrev.length == 3) {
                this.FormEditSubmit.controls["fertilizerFormula"].setValue(
                  this.FormEditSubmit.controls["fertilizerFormula"].value + "-",
                  {
                    emitEvent: false,
                  }
                );
                this.isBackSpace = false;
              }
            } else {
              if (replacePrev.length == 2) {
                this.FormEditSubmit.controls["fertilizerFormula"].setValue(
                  this.FormEditSubmit.controls[
                    "fertilizerFormula"
                  ].value.substring(0, 2) +
                    "-" +
                    replaceNext.substring(2),
                  {
                    emitEvent: false,
                  }
                );
                this.isBackSpace = false;
              } else if (replacePrev.length == 4) {
                this.FormEditSubmit.controls["fertilizerFormula"].setValue(
                  this.FormEditSubmit.controls[
                    "fertilizerFormula"
                  ].value.substring(0, 5) +
                    "-" +
                    replaceNext.substring(4),
                  {
                    emitEvent: false,
                  }
                );
                this.isBackSpace = false;
              }
            }
          }

          if (replacePrev.length > replaceNext.length) {
            if (replacePrev.length == 3) {
              this.FormEditSubmit.controls["fertilizerFormula"].setValue(
                this.FormEditSubmit.controls[
                  "fertilizerFormula"
                ].value.substring(
                  0,
                  this.FormEditSubmit.controls["fertilizerFormula"].value
                    .length - 1
                ),
                {
                  emitEvent: false,
                }
              );
              this.isBackSpace = true;
            }

            if (replacePrev.length == 5) {
              this.FormEditSubmit.controls["fertilizerFormula"].setValue(
                this.FormEditSubmit.controls[
                  "fertilizerFormula"
                ].value.substring(
                  0,
                  this.FormEditSubmit.controls["fertilizerFormula"].value
                    .length - 1
                ),
                {
                  emitEvent: false,
                }
              );
              this.isBackSpace = true;
            }
          }
        });

      this.FormEditSubmit.controls["fertilizerVolume"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["fertilizerVolume"].setValue(
              Number(
                this.FormEditSubmit.controls["fertilizerVolume"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormEditSubmit.controls["fertilizerCost"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["fertilizerCost"].setValue(
              Number(
                this.FormEditSubmit.controls["fertilizerCost"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.clearFormControl(this.FormEditSubmit, "water");
      this.clearFormControl(this.FormEditSubmit, "spray");
      this.clearFormControl(this.FormEditSubmit, "disease");
      this.clearFormControl(this.FormEditSubmit, "weather");
      this.clearFormControl(this.FormEditSubmit, "soil_quality");
      this.clearFormControl(this.FormEditSubmit, "stem_quality");
      
    } else if (this.FormEditSubmit.controls.activity_type.value == "water") {
      if (!this.eventDetail.water) this.eventDetail.water = {};

      this.FormEditSubmit.addControl(
        "waterTime_min",
        new FormControl(
          this.eventDetail.water.time_min != null ? this.eventDetail.water.time_min : "",
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "waterTime_sec",
        new FormControl(
          this.eventDetail.water.time_sec != null ? this.eventDetail.water.time_sec : "",
          Validators.required
        )
      );
      // this.FormEditSubmit.addControl(
      //   "waterVolume",
      //   new FormControl(this.eventDetail.water.volume, Validators.required)
      // );

      this.currentValve = this.valvesList;

      this.clearFormControl(this.FormEditSubmit, "fertilize");
      this.clearFormControl(this.FormEditSubmit, "spray");
      this.clearFormControl(this.FormEditSubmit, "disease");
      this.clearFormControl(this.FormEditSubmit, "weather");
      this.clearFormControl(this.FormEditSubmit, "soil_quality");
      this.clearFormControl(this.FormEditSubmit, "stem_quality");

    } else if (this.FormEditSubmit.controls.activity_type.value == "spray") {
      if (!this.eventDetail.spray) this.eventDetail.spray = {};

      this.FormEditSubmit.addControl(
        "sprayBrand",
        new FormControl(
          this.eventDetail.spray.brand != null ? this.eventDetail.spray.brand : null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "sprayFormula",
        new FormControl(
          this.eventDetail.spray.formula != null ? this.eventDetail.spray.formula : null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "sprayVolume",
        new FormControl(
          this.eventDetail.spray.volume != null ? this.eventDetail.spray.volume : null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "sprayCost",
        new FormControl(
          this.eventDetail.spray.cost != null ? this.eventDetail.spray.cost : null,
          Validators.required
        )
      );

      this.FormEditSubmit.controls["sprayVolume"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["sprayVolume"].setValue(
              Number(this.FormEditSubmit.controls["sprayVolume"].value).toFixed(
                2
              ),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormEditSubmit.controls["sprayCost"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["sprayCost"].setValue(
              Number(this.FormEditSubmit.controls["sprayCost"].value).toFixed(
                2
              ),
              {
                emitEvent: false,
              }
            );
          }
        });
      
      this.clearFormControl(this.FormEditSubmit, "fertilize");
      this.clearFormControl(this.FormEditSubmit, "water");
      this.clearFormControl(this.FormEditSubmit, "disease");
      this.clearFormControl(this.FormEditSubmit, "weather");
      this.clearFormControl(this.FormEditSubmit, "soil_quality");
      this.clearFormControl(this.FormEditSubmit, "stem_quality");

    } else if (this.FormEditSubmit.controls.activity_type.value == "disease") {
      this.loadSearchBar = false;

      this.FormEditSubmit.addControl(
        "disease",
        new FormControl(
          this.eventDetail.disease != null ? this.eventDetail.disease : [],
          Validators.required
        )
      );

      this.FormEditSubmit.addControl(
        "diseasePosition",
        new FormControl(null, Validators.required)
      );

      this.FormEditSubmit.controls.diseasePosition.patchValue(
        this.eventDetail.disease_position ? this.eventDetail.disease_position : null
      );

      if (this.eventDetail.coordinates) {
        this.initMap(
          this.eventDetail.coordinates.center.lat,
          this.eventDetail.coordinates.center.lon,
          this.eventDetail.coordinates.center.zoom_lv
        );
      }

      this.clearFormControl(this.FormEditSubmit, "fertilize");
      this.clearFormControl(this.FormEditSubmit, "water");
      this.clearFormControl(this.FormEditSubmit, "spray");
      this.clearFormControl(this.FormEditSubmit, "weather");
      this.clearFormControl(this.FormEditSubmit, "soil_quality");
      this.clearFormControl(this.FormEditSubmit, "stem_quality");

    } else if (this.FormEditSubmit.controls.activity_type.value == "weather") {
      if (!this.eventDetail.weather) this.eventDetail.weather = {};

      this.FormEditSubmit.addControl(
        "sunlightType",
        new FormControl(
          this.eventDetail.weather.sunlight_conditions != null ? this.eventDetail.weather.sunlight_conditions : "",
          Validators.required,
        )
      );
      this.FormEditSubmit.addControl(
        "windType",
        new FormControl(
          this.eventDetail.weather.wind_strength != null
            ? this.eventDetail.weather.wind_strength
            : "",
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "rainType",
        new FormControl(
          this.eventDetail.weather.rainy_weather != null
            ? this.eventDetail.weather.rainy_weather
            : "",
          Validators.required
        )
      );

      this.clearFormControl(this.FormEditSubmit, "fertilize");
      this.clearFormControl(this.FormEditSubmit, "water");
      this.clearFormControl(this.FormEditSubmit, "spray");
      this.clearFormControl(this.FormEditSubmit, "disease");
      this.clearFormControl(this.FormEditSubmit, "soil_quality");
      this.clearFormControl(this.FormEditSubmit, "stem_quality");
    } else if (
      this.FormEditSubmit.controls.activity_type.value == "soil_quality"
    ) {
      this.loadSearchBar = false;
      if (!this.eventDetail.soil_quality) this.eventDetail.soil_quality = {};

      this.FormEditSubmit.addControl(
        "humidity",
        new FormControl(
          this.eventDetail.soil_quality.humidity? parseFloat(this.eventDetail.soil_quality.humidity).toFixed(2): null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "temperature",
        new FormControl(
          this.eventDetail.soil_quality.temperature? parseFloat(this.eventDetail.soil_quality.temperature).toFixed(2): null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "ph",
        new FormControl(
          this.eventDetail.soil_quality.ph? parseFloat(this.eventDetail.soil_quality.ph).toFixed(2): null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "ec",
        new FormControl(
          this.eventDetail.soil_quality.ec? parseFloat(this.eventDetail.soil_quality.ec).toFixed(2): null,
          Validators.required
        )
      );

      this.FormEditSubmit.addControl(
        "npk",
        new FormControl(
          this.eventDetail.soil_quality.npk? parseFloat(this.eventDetail.soil_quality.npk).toFixed(2): null,
          Validators.required
        )
      );

      this.FormEditSubmit.controls["humidity"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["humidity"].setValue(
              Number(this.FormEditSubmit.controls["humidity"].value).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormEditSubmit.controls["temperature"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["temperature"].setValue(
              Number(this.FormEditSubmit.controls["temperature"].value).toFixed(
                2
              ),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormEditSubmit.controls["ph"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["ph"].setValue(
              Number(this.FormEditSubmit.controls["ph"].value).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormEditSubmit.controls["ec"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["ec"].setValue(
              Number(this.FormEditSubmit.controls["ec"].value).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormEditSubmit.controls["npk"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["npk"].setValue(
              Number(this.FormEditSubmit.controls["npk"].value).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormEditSubmit.addControl(
        "soil_conditions",
        new FormControl(
          this.eventDetail.soil_quality.soil_conditions != null ? this.eventDetail.soil_quality.soil_conditions : null,
          Validators.required
        )
      );

      if (this.eventDetail.coordinates) {
        this.initMap(
          this.eventDetail.coordinates.center.lat,
          this.eventDetail.coordinates.center.lon,
          this.eventDetail.coordinates.center.zoom_lv
        );
      }
      
      this.clearFormControl(this.FormEditSubmit, "fertilize");
      this.clearFormControl(this.FormEditSubmit, "water");
      this.clearFormControl(this.FormEditSubmit, "spray");
      this.clearFormControl(this.FormEditSubmit, "disease");
      this.clearFormControl(this.FormEditSubmit, "weather");
      this.clearFormControl(this.FormEditSubmit, "stem_quality");
    } else if (
      this.FormEditSubmit.controls.activity_type.value == "stem_quality"
    ) {
      this.loadSearchBar = false;
      if (!this.eventDetail.stem_quality) this.eventDetail.stem_quality = {};
      
      this.FormEditSubmit.addControl(
        "leftMoisture1",
        new FormControl(
          this.eventDetail.stem_quality.leaf_moisture_1 != null
            ? this.eventDetail.stem_quality.leaf_moisture_1.toFixed(2)
            : null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "leftMoisture2",
        new FormControl(
          this.eventDetail.stem_quality.leaf_moisture_2 != null
            ? this.eventDetail.stem_quality.leaf_moisture_2.toFixed(2)
            : null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "leftMoisture3",
        new FormControl(
          this.eventDetail.stem_quality.leaf_moisture_3 != null
            ? this.eventDetail.stem_quality.leaf_moisture_3.toFixed(2)
            : null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "leftMoisture4",
        new FormControl(
          this.eventDetail.stem_quality.leaf_moisture_4 != null
            ? this.eventDetail.stem_quality.leaf_moisture_4.toFixed(2)
            : null,
          Validators.required
        )
      );

      this.FormEditSubmit.controls["leftMoisture1"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["leftMoisture1"].setValue(
              Number(
                this.FormEditSubmit.controls["leftMoisture1"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormEditSubmit.controls["leftMoisture2"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["leftMoisture2"].setValue(
              Number(
                this.FormEditSubmit.controls["leftMoisture2"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormEditSubmit.controls["leftMoisture3"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["leftMoisture3"].setValue(
              Number(
                this.FormEditSubmit.controls["leftMoisture3"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });

      this.FormEditSubmit.controls["leftMoisture4"].valueChanges
        .pipe(debounceTime(750), distinctUntilChanged())
        .subscribe((change) => {
          if (change != "") {
            this.FormEditSubmit.controls["leftMoisture4"].setValue(
              Number(
                this.FormEditSubmit.controls["leftMoisture4"].value
              ).toFixed(2),
              {
                emitEvent: false,
              }
            );
          }
        });
      this.FormEditSubmit.addControl(
        "leftMoistureAvg",
        new FormControl(
          this.eventDetail.stem_quality.leaf_moisture_avg != null
            ? this.eventDetail.stem_quality.leaf_moisture_avg.toFixed(2)
            : null,
          Validators.required
        )
      );
      this.FormEditSubmit.addControl(
        "stemHealth",
        new FormControl(
          this.eventDetail.stem_quality.stem_health != null ?
            this.eventDetail.stem_quality.stem_health : null,
          Validators.required
        )
      );

      this.FormEditSubmit.addControl(
        "leafHealth",
        new FormControl(
          this.eventDetail.stem_quality.leaf_health != null ?
            this.eventDetail.stem_quality.leaf_health : null,
          Validators.required
        )
      );

      this.FormEditSubmit.addControl(
        "flowerHealth",
        new FormControl(
          this.eventDetail.stem_quality.flower_health != null ?
            this.eventDetail.stem_quality.flower_health : null,
          Validators.required
        )
      );

      this.FormEditSubmit.addControl(
        "fruitHealth",
        new FormControl(
          this.eventDetail.stem_quality.fruit_health != null ?
            this.eventDetail.stem_quality.fruit_health : null,
          Validators.required
        )
      );

      if (this.eventDetail.coordinates) {
        this.initMap(
          this.eventDetail.coordinates.center.lat,
          this.eventDetail.coordinates.center.lon,
          this.eventDetail.coordinates.center.zoom_lv
        );
      }

      this.clearFormControl(this.FormEditSubmit, "fertilize");
      this.clearFormControl(this.FormEditSubmit, "water");
      this.clearFormControl(this.FormEditSubmit, "spray");
      this.clearFormControl(this.FormEditSubmit, "disease");
      this.clearFormControl(this.FormEditSubmit, "weather");
      this.clearFormControl(this.FormEditSubmit, "soil_quality");
    }

    if (this.eventDetail.pictures) {
      this.eventDetail.pictures.forEach((element) => {
        this.imgEditList.push({ ...element, ...{ type: "old" } });
      });
    }

    this.reset();
  }

  delete_event() {
    $("#eventDeleteConfrimmodal").modal("show");
  }

  async delete_event_confirm() {
    this.spinner.show();
    await this.eventService.deleteEvent(this.eventId).subscribe((result) => {
      if (result.code == 200) {
        $("#successDelModal").modal("show");
      }
      this.spinner.hide();
    });
  }

  //  ================================================================ End DetailEvent ================================================================

  //  ================================================================ Start EditEvent ================================================================
  cancle_edit_event() {
    this.pageName = "detailEvent";
    this.getEvent();
    this.getEventDateil();
  }

  removeImage_Edit(index) {
    if (this.imgEditList[index].type == "old") {
      this.imgEditRemoveList.push({ name: this.imgEditList[index].name });
    }
    this.imgEditList.splice(index, 1);

    this.validateEditAll();
  }

  chkConfirEditSubmit() {
    if (!this.isCanEditSubmit) return;

    if (true) {
      const formData = new FormData();
      formData.append("id", this.eventDetail._id);
      formData.append("title", this.FormEditSubmit.controls.title.value);
      formData.append(
        "activity_type",
        this.FormEditSubmit.controls.activity_type.value == ""
          ? null
          : this.FormEditSubmit.controls.activity_type.value
      );
      formData.append(
        "working_type",
        this.FormEditSubmit.controls.working_type.value == ""
          ? null
          : this.FormEditSubmit.controls.working_type.value
      );
      // formData.append('start_date', this.startDate_reformat);
      // formData.append('end_date', this.endDate_reformat);
      // let start_time = new Date(this.FormEditSubmit.controls.start_time.value);
      // let end_time = new Date(this.FormEditSubmit.controls.end_time.value);
      // const zeroPad = (num, places) => String(num).padStart(places, '0')
      // formData.append('start_date', this.startDate_reformat + " " + zeroPad(start_time.getHours(),2) + ":" + zeroPad(start_time.getMinutes(),2));
      // formData.append('end_date', this.endDate_reformat + " " + zeroPad(end_time.getHours(),2) + ":" + zeroPad(end_time.getMinutes(),2));

      let start_time = new Date(this.startTime);
      let end_time = new Date(this.endTime);
      const zeroPad = (num, places) => String(num).padStart(places, "0");
      formData.append(
        "start_date",
        this.startDate_reformat +
          " " +
          zeroPad(start_time.getHours(), 2) +
          ":" +
          zeroPad(start_time.getMinutes(), 2)
      );
      formData.append(
        "end_date",
        this.endDate_reformat +
          " " +
          zeroPad(end_time.getHours(), 2) +
          ":" +
          zeroPad(end_time.getMinutes(), 2)
      );
      formData.append(
        "poles",
        this.FormEditSubmit.controls.poles.value.length == 0
          ? null
          : JSON.stringify(this.FormEditSubmit.controls.poles.value)
      ); //

      let valveFull = this.FormEditSubmit.controls.valves.value.map((x) => {
        let valve = this.valvesList.find((y) => y._id === x._id);
        return valve;
      });
      formData.append(
        "valves",
        valveFull.length == 0 ? null : JSON.stringify(valveFull)
      );

      formData.append(
        "fertilize",
        this.FormEditSubmit.controls.activity_type.value == "fertilize"
          ? JSON.stringify({
              brand:
                this.FormEditSubmit.controls.fertilizerBrand.value == ""
                  ? null
                  : this.FormEditSubmit.controls.fertilizerBrand.value,
              formula:
                this.FormEditSubmit.controls.fertilizerFormula.value == ""
                  ? null
                  : this.FormEditSubmit.controls.fertilizerFormula.value,
              volume:
                this.FormEditSubmit.controls.fertilizerVolume.value == ""
                  ? null
                  : this.FormEditSubmit.controls.fertilizerVolume.value,
              cost:
                this.FormEditSubmit.controls.fertilizerCost.value == ""
                  ? null
                  : this.FormEditSubmit.controls.fertilizerCost.value,
            })
          : null
      );
      formData.append(
        "water",
        this.FormEditSubmit.controls.activity_type.value == "water"
          ? JSON.stringify({
              time_min: 
                this.FormEditSubmit.controls.waterTime_min.value != ""
                  ? this.FormEditSubmit.controls.waterTime_min.value
                  : null,
              time_sec:
                this.FormEditSubmit.controls.waterTime_sec.value != ""
                  ? this.FormEditSubmit.controls.waterTime_sec.value
                  : null,
              // volume: this.FormEditSubmit.controls.waterVolume.value,
            })
          : null
      );
      formData.append(
        "spray",
        this.FormEditSubmit.controls.activity_type.value == "spray"
          ? JSON.stringify({
              brand:
                this.FormEditSubmit.controls.sprayBrand.value == ""
                  ? null
                  : this.FormEditSubmit.controls.sprayBrand.value,
              formula:
                this.FormEditSubmit.controls.sprayFormula.value == ""
                  ? null
                  : this.FormEditSubmit.controls.sprayFormula.value,
              volume: 
                this.FormEditSubmit.controls.sprayVolume.value == ""
                  ? null
                  : this.FormEditSubmit.controls.sprayVolume.value,
              cost:
                this.FormEditSubmit.controls.sprayCost.value == ""
                  ? null
                  : this.FormEditSubmit.controls.sprayCost.value,
            })
          : null
      );
      formData.append(
        "disease",
        this.FormEditSubmit.controls.activity_type.value == "disease"
          ? JSON.stringify(this.FormEditSubmit.controls.disease.value)
          : null
      );

      formData.append(
        "disease_position",
        this.FormEditSubmit.controls.activity_type.value == "disease"
          ? this.FormEditSubmit.controls.diseasePosition.value == ""
            ? null
            : this.FormEditSubmit.controls.diseasePosition.value
          : null
      );

      formData.append(
        "weather",
        this.FormEditSubmit.controls.activity_type.value == "weather"
          ? JSON.stringify({
              sunlight_conditions:
                this.FormEditSubmit.controls.sunlightType.value != ""
                  ? this.FormEditSubmit.controls.sunlightType.value
                  : null,
              wind_strength:
                this.FormEditSubmit.controls.windType.value != ""
                  ? this.FormEditSubmit.controls.windType.value
                  : null,
              rainy_weather:
                this.FormEditSubmit.controls.rainType.value != ""
                  ? this.FormEditSubmit.controls.rainType.value
                  : null,
            })
          : null
      );

      formData.append(
        "soil_quality",
        this.FormEditSubmit.controls.activity_type.value == "soil_quality"
          ? JSON.stringify({
              humidity:
                this.FormEditSubmit.controls.humidity.value == ""
                  ? null
                  : this.FormEditSubmit.controls.humidity.value,
              temperature:
                this.FormEditSubmit.controls.temperature.value == ""
                  ? null
                  : this.FormEditSubmit.controls.temperature.value,
              ph:
                this.FormEditSubmit.controls.ph.value == ""
                  ? null
                  : this.FormEditSubmit.controls.ph.value,
              ec:
                this.FormEditSubmit.controls.ec.value == ""
                  ? null
                  : this.FormEditSubmit.controls.ec.value,
              npk:
                this.FormEditSubmit.controls.npk.value == ""
                  ? null
                  : this.FormEditSubmit.controls.npk.value,
              soil_conditions:
                this.FormEditSubmit.controls.soil_conditions.value == ""
                  ? null
                  : this.FormEditSubmit.controls.soil_conditions.value,
            })
          : null
      );

      formData.append(
        "stem_quality",
        this.FormEditSubmit.controls.activity_type.value == "stem_quality"
          ? JSON.stringify({
              leaf_moisture_1:
                this.FormEditSubmit.controls.leftMoisture1.value == ""
                  ? null
                  : this.FormEditSubmit.controls.leftMoisture1.value,
              leaf_moisture_2:
                this.FormEditSubmit.controls.leftMoisture2.value == ""
                  ? null
                  : this.FormEditSubmit.controls.leftMoisture2.value,
              leaf_moisture_3:
                this.FormEditSubmit.controls.leftMoisture3.value == ""
                  ? null
                  : this.FormEditSubmit.controls.leftMoisture3.value,
              leaf_moisture_4:
                this.FormEditSubmit.controls.leftMoisture4.value == ""
                  ? null
                  : this.FormEditSubmit.controls.leftMoisture4.value,
              leaf_moisture_avg:
                this.FormEditSubmit.controls.leftMoistureAvg.value == ""
                  ? null
                  : this.FormEditSubmit.controls.leftMoistureAvg.value,

              stem_health:
                this.FormEditSubmit.controls.stemHealth.value != ""
                  ? this.FormEditSubmit.controls.stemHealth.value
                  : null,

              leaf_health:
                this.FormEditSubmit.controls.leafHealth.value != ""
                  ? this.FormEditSubmit.controls.leafHealth.value
                  : null,
              flower_health:
                this.FormEditSubmit.controls.flowerHealth.value != ""
                  ? this.FormEditSubmit.controls.flowerHealth.value
                  : null,
              fruit_health:
                this.FormEditSubmit.controls.fruitHealth.value != ""
                  ? this.FormEditSubmit.controls.fruitHealth.value
                  : null,
            })
          : null
      );

      formData.append(
        "coordinates",
        this.FormEditSubmit.controls.activity_type.value == "soil_quality" ||
        this.FormEditSubmit.controls.activity_type.value == "stem_quality" ||
        this.FormEditSubmit.controls.activity_type.value == "disease"
          ? JSON.stringify({
              center: {
                lat: this.markers[0].lat,
                lon: this.markers[0].lng,
                zoom_lv: this.zoom,
              },
            })
          : null
      );

      // return;

      formData.append("status", this.FormEditSubmit.controls.status.value);
      formData.append(
        "remark",
        this.FormEditSubmit.controls.remark.value == null
          ? ""
          : this.FormEditSubmit.controls.remark.value
      );
      formData.append(
        "assign_to",
        this.FormEditSubmit.controls.assign_to.value
        ? this.FormEditSubmit.controls.assign_to.value.toString()
        : null
      );

      let imageNew = this.imgEditList.filter((x) => x.type == "new");
      for (let index = 0; index < imageNew.length; index++) {
        const element = imageNew[index];
        let i = Number(index) + 1;
        formData.append("pic_" + i.toString(), element.file);
      }
      formData.append("remove_pic", JSON.stringify(this.imgEditRemoveList));

      this.spinner.show();
      this.eventService.editEvent(formData).subscribe((result) => {
        if (result.code == 200) {
          // this.getEvent();
          // this.getEventDateil();
          $("#eventEditSuccessmodal").modal("show");
        }
        this.spinner.hide();
      });
    } else {
      $("#eventEditFailmodal").modal("show");
    }
  }

  mapClicked($event: MouseEvent) {
    this.markers[0].lat = $event.coords.lat;
    this.markers[0].lng = $event.coords.lng;
  }

  clickedMarker(label: string, index: number, lat: number, lng: number) {

    let url =
      "https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" +
      lat +
      "," +
      lng;
    window.open(url, "_blank");
  }
  openGooglemap() {
    let url =
      "https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" +
      this.markers[0].lat +
      "," +
      this.markers[0].lng;
    window.open(url, "_blank");
  }

  decimalFilter(event: any) {
    const reg = /^\d*(\.\d{0,2})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  plantFilter(event: any) {
    const reg = /^[0-9a-zA-Zก-๙]+$/;

    const input =
      event.target.value + String.fromCharCode(event.charCode);
  
    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  validateAll(event = null) {

    let isCommonInvalid = false;

    if (
      this.FormCreateSubmit.controls.title.value == "" ||
      this.FormCreateSubmit.controls.start_date.value == "" ||
      this.FormCreateSubmit.controls.end_date.value == "" // ||
      // this.FormCreateSubmit.controls.activity_type.value == "" ||
      // this.FormCreateSubmit.controls.working_type.value == "" ||
      // this.FormCreateSubmit.controls.assign_to.value == ""
    ) {
      isCommonInvalid = true;
    } else {
      isCommonInvalid = false;
    }

    // Since activity_type and all of its fields are optional now
    if (isCommonInvalid) {
      this.isCanSubmit = false;
    } else {
      this.isCanSubmit = true;
    }

    /* 
    if (this.FormCreateSubmit.controls.activity_type.value == "fertilize") {
      if (
        isCommonInvalid ||
        // this.FormCreateSubmit.controls.fertilizerFormula.value == "" ||
        // this.FormCreateSubmit.controls.fertilizerFormula.value.length != 8 ||
        // this.FormCreateSubmit.controls.fertilizerBrand.value == "" ||
        this.FormCreateSubmit.controls.fertilizerVolume.value == ""
        // ||
        // this.FormCreateSubmit.controls.fertilizerCost.value == ""
      ) {
        this.isCanSubmit = false;
      } else {
        this.isCanSubmit = true;
      }
    }

    if (
      this.FormCreateSubmit.controls.activity_type.value == "store_pictures"
    ) {
      if (isCommonInvalid || this.imgCreateList.length <= 0) {
        this.isCanSubmit = false;
      } else {
        this.isCanSubmit = true;
      }
    }

    if (this.FormCreateSubmit.controls.activity_type.value == "water") {
      if (
        isCommonInvalid ||
        // this.currentValve.length == 0 ||
        this.FormCreateSubmit.controls.waterTime_min.value == "" ||
        this.FormCreateSubmit.controls.waterTime_sec.value == ""
      ) {
        this.isCanSubmit = false;
      } else {
        this.isCanSubmit = true;
      }
    }

    if (this.FormCreateSubmit.controls.activity_type.value == "spray") {
      if (
        isCommonInvalid ||
        // this.FormCreateSubmit.controls.sprayBrand.value == "" ||
        // this.FormCreateSubmit.controls.sprayFormula.value == "" ||
        this.FormCreateSubmit.controls.sprayVolume.value == ""
        //  ||
        // this.FormCreateSubmit.controls.sprayCost.value == ""
      ) {
        this.isCanSubmit = false;
      } else {
        this.isCanSubmit = true;
      }
    }

    if (this.FormCreateSubmit.controls.activity_type.value == "disease") {
      if (
        isCommonInvalid ||
        this.FormCreateSubmit.controls.disease.value.length == 0
      ) {
        this.isCanSubmit = false;
      } else {
        this.isCanSubmit = true;
      }
    }

    if (this.FormCreateSubmit.controls.activity_type.value == "stem_quality") {
      if (
        isCommonInvalid ||
        this.FormCreateSubmit.controls.stemHealth.value == ""
      ) {
        this.isCanSubmit = false;
      } else {
        this.isCanSubmit = true;
      }
    }

    if (this.FormCreateSubmit.controls.activity_type.value == "soil_quality") {
      if (
        isCommonInvalid ||
        this.FormCreateSubmit.controls.soil_conditions.value == ""
      ) {
        this.isCanSubmit = false;
      } else {
        this.isCanSubmit = true;
      }
    }

    if (this.FormCreateSubmit.controls.activity_type.value == "weather") {
      if (
        isCommonInvalid ||
        this.FormCreateSubmit.controls.sunlightType.value == ""
      ) {
        this.isCanSubmit = false;
      } else {
        this.isCanSubmit = true;
      }
    }
    */

    this.reset();
  }

  validateEditAll(event = null) {
    let isCommonInvalid = false;

    if (
      this.FormEditSubmit.controls.title.value == "" ||
      this.FormEditSubmit.controls.start_date.value == "" ||
      this.FormEditSubmit.controls.end_date.value == "" // ||
      // this.FormEditSubmit.controls.activity_type.value == "" ||
      // this.FormEditSubmit.controls.working_type.value == "" ||
      // this.FormEditSubmit.controls.assign_to.value == ""
    ) {
      isCommonInvalid = true;
    } else {
      isCommonInvalid = false;
    }

    // Since activity_type and all of its fields are optional now
    if (isCommonInvalid) {
      this.isCanSubmit = false;
    } else {
      this.isCanSubmit = true;
    }

    /*
    if (this.FormEditSubmit.controls.activity_type.value == "fertilize") {
      if (
        isCommonInvalid ||
        // this.FormEditSubmit.controls.fertilizerFormula.value == "" ||
        // this.FormEditSubmit.controls.fertilizerFormula.value.length != 8 ||
        // this.FormEditSubmit.controls.fertilizerBrand.value == "" ||
        this.FormEditSubmit.controls.fertilizerVolume.value == ""
        // ||
        // this.FormEditSubmit.controls.fertilizerCost.value == ""
      ) {
        this.isCanEditSubmit = false;
      } else {
        this.isCanEditSubmit = true;
      }
    }

    if (this.FormEditSubmit.controls.activity_type.value == "store_pictures") {
      if (isCommonInvalid || this.imgEditList.length <= 0) {
        this.isCanEditSubmit = false;
      } else {
        this.isCanEditSubmit = true;
      }
    }

    if (this.FormEditSubmit.controls.activity_type.value == "water") {
      if (
        isCommonInvalid ||
        // this.currentValve.length == 0 ||
        this.FormEditSubmit.controls.waterTime_min.value == "" ||
        this.FormEditSubmit.controls.waterTime_sec.value == ""
      ) {
        this.isCanEditSubmit = false;
      } else {
        this.isCanEditSubmit = true;
      }
    }

    if (this.FormEditSubmit.controls.activity_type.value == "spray") {
      if (
        isCommonInvalid ||
        // this.FormEditSubmit.controls.sprayBrand.value == "" ||
        // this.FormEditSubmit.controls.sprayFormula.value == "" ||
        this.FormEditSubmit.controls.sprayVolume.value == ""
        // ||
        // this.FormEditSubmit.controls.sprayCost.value == ""
      ) {
        this.isCanEditSubmit = false;
      } else {
        this.isCanEditSubmit = true;
      }
    }

    if (this.FormEditSubmit.controls.activity_type.value == "disease") {
      if (
        isCommonInvalid ||
        this.FormEditSubmit.controls.disease.value.length == 0
      ) {
        this.isCanEditSubmit = false;
      } else {
        this.isCanEditSubmit = true;
      }
    }

    if (this.FormEditSubmit.controls.activity_type.value == "stem_quality") {
      if (
        isCommonInvalid ||
        this.FormEditSubmit.controls.stemHealth.value == ""
      ) {
        this.isCanEditSubmit = false;
      } else {
        this.isCanEditSubmit = true;
      }
    }

    if (this.FormEditSubmit.controls.activity_type.value == "soil_quality") {
      if (
        isCommonInvalid ||
        this.FormEditSubmit.controls.soil_conditions.value == ""
      ) {
        this.isCanEditSubmit = false;
      } else {
        this.isCanEditSubmit = true;
      }
    }

    if (this.FormEditSubmit.controls.activity_type.value == "weather") {
      if (
        isCommonInvalid ||
        this.FormEditSubmit.controls.sunlightType.value == ""
      ) {
        this.isCanEditSubmit = false;
      } else {
        this.isCanEditSubmit = true;
      }
    }
    */

    this.reset();
  }

  preventFilter(event: any) {
    event.preventDefault();
  }

  calAverage(event: any, type = "CREATE") {
    let count = 0;

    if (type == "CREATE") {
      if (
        this.FormCreateSubmit.controls.leftMoisture1.value != "" &&
        this.FormCreateSubmit.controls.leftMoisture1.value != null
      ) {
        count = count + 1;
      }
      if (
        this.FormCreateSubmit.controls.leftMoisture2.value != "" &&
        this.FormCreateSubmit.controls.leftMoisture2.value != null
      ) {
        count = count + 1;
      }
      if (
        this.FormCreateSubmit.controls.leftMoisture3.value != "" &&
        this.FormCreateSubmit.controls.leftMoisture3.value != null
      ) {
        count = count + 1;
      }
      if (
        this.FormCreateSubmit.controls.leftMoisture4.value != "" &&
        this.FormCreateSubmit.controls.leftMoisture4.value != null
      ) {
        count = count + 1;
      }

      const sumAvg =
        (parseFloat(
          this.FormCreateSubmit.controls.leftMoisture1.value == "" ||
            this.FormCreateSubmit.controls.leftMoisture1.value == null
            ? "0"
            : this.FormCreateSubmit.controls.leftMoisture1.value
        ) +
          parseFloat(
            this.FormCreateSubmit.controls.leftMoisture2.value == "" ||
              this.FormCreateSubmit.controls.leftMoisture2.value == null
              ? "0"
              : this.FormCreateSubmit.controls.leftMoisture2.value
          ) +
          parseFloat(
            this.FormCreateSubmit.controls.leftMoisture3.value == "" ||
              this.FormCreateSubmit.controls.leftMoisture3.value == null
              ? "0"
              : this.FormCreateSubmit.controls.leftMoisture3.value
          ) +
          parseFloat(
            this.FormCreateSubmit.controls.leftMoisture4.value == "" ||
              this.FormCreateSubmit.controls.leftMoisture4.value == null
              ? "0"
              : this.FormCreateSubmit.controls.leftMoisture4.value
          )) /
        count;

      this.FormCreateSubmit.controls.leftMoistureAvg.setValue(sumAvg);
    } else {
      if (
        this.FormEditSubmit.controls.leftMoisture1.value != "" &&
        this.FormEditSubmit.controls.leftMoisture1.value != null
      ) {
        count = count + 1;
      }
      if (
        this.FormEditSubmit.controls.leftMoisture2.value != "" &&
        this.FormEditSubmit.controls.leftMoisture2.value != null
      ) {
        count = count + 1;
      }
      if (
        this.FormEditSubmit.controls.leftMoisture3.value != "" &&
        this.FormEditSubmit.controls.leftMoisture3.value != null
      ) {
        count = count + 1;
      }
      if (
        this.FormEditSubmit.controls.leftMoisture4.value != "" &&
        this.FormEditSubmit.controls.leftMoisture4.value != null
      ) {
        count = count + 1;
      }

      let sumAvg =
        (parseFloat(
          this.FormEditSubmit.controls.leftMoisture1.value == "" ||
            this.FormEditSubmit.controls.leftMoisture1.value == null
            ? "0"
            : this.FormEditSubmit.controls.leftMoisture1.value
        ) +
          parseFloat(
            this.FormEditSubmit.controls.leftMoisture2.value == "" ||
              this.FormEditSubmit.controls.leftMoisture2.value == null
              ? "0"
              : this.FormEditSubmit.controls.leftMoisture2.value
          ) +
          parseFloat(
            this.FormEditSubmit.controls.leftMoisture3.value == "" ||
              this.FormEditSubmit.controls.leftMoisture3.value == null
              ? "0"
              : this.FormEditSubmit.controls.leftMoisture3.value
          ) +
          parseFloat(
            this.FormEditSubmit.controls.leftMoisture4.value == "" ||
              this.FormEditSubmit.controls.leftMoisture4.value == null
              ? "0"
              : this.FormEditSubmit.controls.leftMoisture4.value
          )) /
        count;

      if (isNaN(sumAvg)) sumAvg = 0;

      this.FormEditSubmit.controls.leftMoistureAvg.setValue(sumAvg);
    }
  }

  //  ================================================================= End EditEvent =================================================================
}
interface marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
  icon?: string;
}
